import { Header } from "./header";

import type { JSX, ReactNode } from "react";

interface LayoutProps {
  children: ReactNode;
}

export const Layout = ({ children }: LayoutProps): JSX.Element => (
  <div className="min-h-screen bg-white dark:bg-gray-900">
    <Header />
    <main className="container mx-auto px-4 py-8">{children}</main>
  </div>
);
